export default "__VITE_ASSET__CONyDmjB__"